import { getFontCss, styleConstants } from '@paywithextend/components'
import React from 'react'
import Box from 'src/components/Box/Box'
import TextInputField, {
  TextInputFieldDesigns,
} from 'src/components/TextInputField/TextInputField'
import { css } from 'styled-components'

interface UserAndNameInputBoxProps {
  className?: string
  fieldLabel: React.ReactElement
  placeholder: string
  baseValue: string | undefined
  showUpdates: boolean
  value: string | undefined
  errors: Array<React.ReactElement | string> | undefined
  onChange: (val: string) => void
  testId?: string
}

const UserAndNameInputBox: React.FC<UserAndNameInputBoxProps> = (
  props,
): React.ReactElement => {
  return (
    <Box
      className={props.className}
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <TextInputField
        fieldLabel={props.fieldLabel}
        design={TextInputFieldDesigns.New}
        placeholder={props.placeholder}
        showUpdates={props.showUpdates}
        baseValue={props.baseValue}
        value={props.value}
        errors={props.errors}
        onChange={props.onChange}
        id={props.fieldLabel.props.source.split(' ').join('')}
        css={css`
          ${getFontCss(
            16,
            styleConstants.colors.gray_darkest,
            styleConstants.fontFamilies.regular,
          )};
        `}
        data-testid={props.testId}
      />
    </Box>
  )
}

export default UserAndNameInputBox
